module.exports = __webpack_public_path__ + "img/overview-orange.e24a21c8.svg";